export default __webpack_public_path__ + "static/media/intro_img2.29234cfa.png";